import { style } from '@vanilla-extract/css'

const form = style({
  width: '100%',
  maxWidth: '480px',
})

const input = style({
  width: '100%',
  height: '44px',
  padding: '0 12px',
  borderRadius: '8px',
  border: '0.5px solid #00000014',
  backgroundColor: 'white',
  boxShadow: '0px 0px 4px 0px #1230480A',
  fontSize: '14px',
  fontWeight: '700',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
  selectors: {
    '&:focus-visible': {
      outline: '1px solid #E46327',
      outlineOffset: '-1px',
      boxShadow: 'none',
    },
  },
})

const error = style({
  color: '#ED0006',
  fontSize: '13px',
  lineHeight: '1.5',
})

export const styles = {
  form,
  input,
  error,
}
